
<app-leveltwo [pageName]="'General Info'">
  <!-- <tabset #staticTabs> -->
    <!-- <tab heading="Achievements"> -->
      <ng-content select=".Achievements">
      </ng-content>
        <div class="General">
          <h3>Awards</h3>

          <h4>2024</h4>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1694464443/Images/CEAA_Logo_High_Res.jpg" style="width:90%" alt="CEAA – Certificate of Excellence in Assessment Administration Logo">
                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1721924862/Images/2024_NACo.png" style="width:90%" alt="NaCo 2024 Achievement Award Logo">
                </div>

              </div>
            </div>
            <div class="col-md-8 awardslist" style="text-transform: uppercase;">
              <ul>
                <li><h5>INTERNATIONAL ASSOCIATION OF ASSESSING OFFICERS (IAAO)</h5><b>DISTINGUISHED ASSESSMENT JURISDICTION AWARD</b></li><br>
                <li><h5>NATIONAL ASSOCIATION OF COUNTIES (NACO) Achievement Award</h5><b>Assessor Homeowner Alert Service e-Notification</b></li><br>
                <li><h5>NACo</h5><b>Assessor Online Form e-File</b></li><br>
                <li><h5>NACo</h5><b>Assessor Website e-Service Constituent Self-Registration (CSR) Portal</b></li><br>
                <li><h5>NACo</h5><b>California Assessors' Association Public Affairs Working Group</b></li><br>
              </ul>
            </div>
          </div>

          <h4>2023</h4>
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1694464443/Images/CEAA_Logo_High_Res.jpg" style="width:90%" alt="CEAA – Certificate of Excellence in Assessment Administration Logo">
                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1666711139/Images/qpc.jpg" style="width:90%" alt="Quality and Productivity Commission Logo">
                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1686059242/Images/2023_naco_achievementawards.png" style="width:90%" alt="NaCo 2023 Achievement Award Logo">
                </div>
              </div>
            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>IAAO</h5><b>CERTIFICATE OF EXCELLENCE IN ASSESSMENT ADMINISTRATION</b></li><br>
                <li><h5>IAAO</h5><b>PUBLIC INFORMATION PROGRAM AWARD</b></li><br>
                <li><h5>36TH ANNUAL PRODUCTIVITY AND QUALITY AWARDS</h5><b>SPECIAL MERIT AWARD</b><br>Assessor’s Workforce Development Program</li><br>
                <li><h5>NACo</h5><b>APPRAISER ASSISTANT TRAINING PROGRAM</b></li><br>
                <li><h5>NACo</h5><b>ASSESSOR’S CHATBOT</b></li><br>
                <li><h5>NACo</h5><b>ASSESSOR’S HOMEOWNERS' RESOURCE FAIRS</b></li><br>
                <li><h5>NACo</h5><b>ONLINE APPOINTMENT BOOKING SYSTEM</b></li><br>
              </ul>
            </div>
          </div>

          <h4>2022</h4>
          <div class="row">

            <div class="col-md-4">



              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/quality-productivity_logo_2_vruncv.jpg" style="width:100%" alt="Quality and Productivity Commission Logo">

                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1666711542/Images/naco_2022.jpg" style="width:90%" alt="NaCo 2022 Achievement Award Logo">
                </div>

              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>35th Annual Productivity and Quality Awards</h5><b>TOP 10 AWARDS</b></li><p>This is Our Shot! Mobile Vaccine Team Fights COVID (Public Health, First, Second, Third, Fourth, and Fifth Supervisorial Districts, Assessor, Beaches and Harbors, Chief Executive Office, Children and Family Services, Fire, LA County Library, Los Angeles County Office of Education, Parks and Recreation, and Public Social Services)</p><br>
                <li><h5>NACo</h5><b>APPRAISER TRAINING AND WORKFORCE DEVELOPMENT</b></li><br>
              </ul>
            </div>
          </div>

          <br>

          <h4>2021</h4>
          <div class="row">

            <div class="col-md-4">

              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1626297688/Images/2021-NACo-Achievement-Award-Winner-Seal.png" style="width:80%" alt="NaCo 2021 Achievement Award Logo">
                </div>

              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>NACo</h5><b>AABS VIRTUAL HEARING SOLUTION</b></li><br>

              </ul>
            </div>
          </div>

          <br>

          <h4>2019</h4>
          <div class="row">

            <div class="col-md-4">

              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1694464443/Images/CEAA_Logo_High_Res.jpg" style="width:100%" alt="CEAA – Certificate of Excellence in Assessment Administration Logo">
                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/NACo2019-Award-2_krigrs.jpg" style="width:100%" alt="NaCo 2019 Achievement Award Logo">
                </div>

              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>IAAO</h5><b>CERTIFICATE OF EXCELLENCE IN ASSESSMENT ADMINISTRATION</b></li><br>
                <li><h5>NACo</h5><b>MOBILE ASSETS TRACKING SYSTEM (MATS)</b></li><br>
                <li><h5>NACo</h5><b>TRAIN TRACKS</b></li><br>

                <li><h5>LA County Stars</h5><b>PROPERTY TAX PORTAL</b></li><br>
              </ul>
            </div>
          </div>

          <h4>2018</h4>
          <div class="row">

            <div class="col-md-4">

              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1694464443/Images/CEAA_Logo_High_Res.jpg" style="width:100%" alt="CEAA – Certificate of Excellence in Assessment Administration Logo">
                </div>
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/quality-productivity_logo_2_vruncv.jpg" style="width:100%" alt="Quality and Productivity Commission Logo">
                </div>
                <div class="col-md-5" >
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1624052138/Images/government-technology-logo-01.svg" style="width:100%" alt="LA Digital Government Logo">
                </div>

                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/Urisa_awards_ip8qfg.png" style="width:100%" alt="Urisa Exemplary Systems in Government Logo">
                </div>
              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>IAAO</h5><b><p>CERTIFICATE OF EXCELLENCE IN ASSESSMENT ADMINISTRATION</p></b></li><br>
                <li><h5>31st Annual Productivity and Quality Awards</h5><b><p>SPECIAL MERITS AWARDS</p></b><p>One-Stop Service Public Counter (collaboration with Treasurer & Tax Collector and Auditor-Controller)</p></li><br>
                <!-- <li><h5>NACo Achievement Award</h5><b><p>TRAIN TRACKS</p></b><p>Roy Jean Wilson & Cherwell Team</p></li><br> -->

                <li><h5>URISA Exemplary Systems in Government (ESIG) Award</h5><b><p>THE ASSESSOR PORTAL</p></b></li><br>
                <li><h5>LA Digital Government Award</h5><b><p>CHERWELL E-FORMS INITIATIVE</p></b></li><br>
              </ul>
            </div>
          </div>

          <h4>2017</h4>
          <div class="row">

            <div class="col-md-4">

              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/quality-productivity_logo_2_vruncv.jpg" style="width:100%" alt="Quality and Productivity Commission Logo">
                </div>
                <div class="col-md-5" >
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/Winner-Seal_04_24_17_uygrdy.jpg" style="width:100%" alt="NaCo 2017 Achievement Award Logo">
                </div>

              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>30th Annual Productivity and Quality Awards</h5><b><p>BRONZE EAGLE</p></b><p>Assessor Portal</p></li><br>
                <li><h5>NACo</h5><b><p>COUNTY ADMINISTRATION AND MANAGEMENT</p></b><p>New Online Portal Brings the Office of the Assessor into the 21st Century</p></li><br>
                <li><h5>LA Digital Government Award</h5><b><p>ASSESSOR MODERNIZATION PROJECT</p></b></li><br>
              </ul>
            </div>
          </div>

          <h4>2016</h4>
          <div class="row">

            <div class="col-md-4">

              <div class="row">
                <div class="col-md-5">
                  <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622667727/Images/quality-productivity_logo_2_vruncv.jpg" style="width:100%" alt="Quality and Productivity Commission Logo">
                </div>

              </div>

            </div>
            <div class="col-md-8 awardslist">
              <ul>
                <li><h5>29th Annual Productivity and Quality Awards</h5><b><p>PERFORMANCE MEASUREMENT AWARD</p></b><p>Special Investigation Tracking System (SITS)</p></li><br>
                <li><h5>29th Annual Productivity and Quality Awards</h5><b><p>TOP TEN AWARD </p></b><p>Assessor Portal</p></li><br>
              </ul>
            </div>
          </div>

        </div>

    <!-- </tab> -->
    <!--
    <tab heading="Videos">
      <ng-content select=".Videos">
      </ng-content>
      <div class="General">
          <h3>Videos</h3>
        </div>
    </tab>
-->

  <!-- </tabset> -->
</app-leveltwo>




